// this is a wrapper around react-number-format to make it controlled
// for more info see https://github.com/s-yadav/react-number-format/issues/700

import { styled } from '@mui/material';
import * as React from 'react';
import NumberFormat from 'react-number-format';

export function ControlledNumericFormat({ value: propValue, onValueChange, height = 0, ...props }) {
    const [value, setValue] = React.useState(propValue);

    React.useEffect(() => {
        if (propValue !== value) {
            setValue(propValue);
        }
    }, [propValue, value]);

    function handleChange(values: any) {
        onValueChange(values);
        setValue(values.floatValue);
    }

    return <StyledNumberFormat value={value} onValueChange={handleChange} height={height} {...props} />;
}

export function ControlledNumericInput({ value: propValue, onValueChange, ...props }: React.ComponentProps<typeof NumberFormat>) {
    const [value, setValue] = React.useState(propValue);

    React.useEffect(() => {
        if (propValue !== value) {
            setValue(propValue);
        }
    }, [propValue, value]);

    function handleChange(values: any, source: any) {
        if (value === values.floatValue) return;
        onValueChange && onValueChange(values, source);
        setValue(values.floatValue);
    }

    return <NumberFormat value={value} onValueChange={handleChange} {...props} />;
}

const StyledNumberFormat = styled(NumberFormat)(({ theme, height }) => ({
    '& .MuiInputBase-root': {
        height: height ? `${height}px` : undefined,
    },
    '& .MuiFormLabel-root[data-shrink="false"]': {
        marginTop: height ? `${(height as any) / 6}px` : undefined,
    },
}));
